import { render } from "./LinuxView.vue?vue&type=template&id=6a6dd3ba&scoped=true"
import script from "./LinuxView.vue?vue&type=script&lang=js"
export * from "./LinuxView.vue?vue&type=script&lang=js"

import "./LinuxView.vue?vue&type=style&index=0&id=6a6dd3ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6dd3ba"]])

export default __exports__